import { render, staticRenderFns } from "./CountryOverviewDetailsSoortTable.vue?vue&type=template&id=82a2c1e8&"
import script from "./CountryOverviewDetailsSoortTable.vue?vue&type=script&lang=js&"
export * from "./CountryOverviewDetailsSoortTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports